module.exports = __webpack_public_path__ + "static/media/it-department-website.11325647.md";